import { Button, IconChevronLeftDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { QuizMachineContext } from '../../context'
import { useQuizEvents } from '../../events'

interface BackButtonProps {
  size?: 'md' | 'sm'
  iconSize?: 'scale-8' | 'sm'
}

export const BackButton = ({ size, iconSize }: BackButtonProps) => {
  const actor = QuizMachineContext.useActorRef()
  const currentState = actor.getSnapshot()
  const { trackBackButtonClicked } = useQuizEvents()
  const { t } = useTranslation('@mc/next')

  const handleBack = () => {
    trackBackButtonClicked()
    actor.send({ type: 'back' })
  }

  if (!currentState?.can({ type: 'back' })) return <></>

  return (
    <Button
      className='mc-p-3'
      onClick={handleBack}
      kind='tertiary'
      size={size}
      symmetrical
    >
      <IconChevronLeftDefault
        size={iconSize}
        srText={t('findMyClasses.common.a11y.back')}
      />
    </Button>
  )
}
